import React, { Component } from 'react'

import { Input } from '@/components/ui/input'
import CopyToClipboard from './CopyToClipboard'
import SnippetsButton from './SnippetsButton'
import Preferences from './Preferences'

import '../App.css'

class FormInput extends Component {
    constructor(props) {
        super(props)
        this.inputToFocus = null
        this.onValueRetrieved = this.onValueRetrieved.bind(this)
        this.onValueChange = this.onValueChange.bind(this)
    }

    componentDidMount() {
        if (Preferences.getGlobalValue("focus") && this.props.focusOnMount && this.inputToFocus) {
            this.inputToFocus.focus()
        }
    }

    onValueRetrieved(event, text) {
        if (event && event.target && this.props.onChange) {
            event.target.value = text
            event.preventDefault()
            this.props.onChange(event)
        }
    }

    onValueChange(event) {
        if (this.props.onChange) {
            event.preventDefault()
            this.props.onChange(event)
        }
    }

    render() {
        const formControlProps = Object.assign({}, this.props)
        delete formControlProps.preferencesKey
        delete formControlProps.preferencesItemKey
        delete formControlProps.invalidMessage
        delete formControlProps.validMessage
        delete formControlProps.focusOnMount
        delete formControlProps.value
        delete formControlProps.onChange
        delete formControlProps.type

        const isInvalid = !!this.props.invalidMessage
        const isValid = !!this.props.validMessage

        return (
            <div className="w-full">
                <div className="flex items-stretch w-full">
                    <Input
                        type="text"
                        aria-describedby="inputGroupPrepend"
                        autoComplete={ "off" }
                        autoCorrect={ "off" }
                        spellCheck={ "false" }
                        className={ "flex-1 rounded-r-none h-auto text-base" + (isInvalid ? " border-destructive" : "") + (isValid ? " border-green-500" : "") }
                        ref={ ref => this.inputToFocus = ref }
                        value={ this.props.value }
                        onChange={ this.onValueChange }
                        {...formControlProps}
                    />
                    <div id="inputGroupPrepend" className="flex items-center gap-1 px-2 border border-l-0 rounded-r-lg bg-muted/40 border-border">
                        <CopyToClipboard text={ this.props.value } noOutline />
                        <SnippetsButton text={ this.props.value } onTextRetrieved={ this.onValueRetrieved } noOutline />
                    </div>
                </div>
                { this.props.invalidMessage &&
                    <p className="text-sm text-destructive mt-1">{ this.props.invalidMessage }</p>
                }
                { this.props.validMessage &&
                    <p className="text-sm text-green-600 mt-1">{ this.props.validMessage }</p>
                }
            </div>
        )
    }
}

export default FormInput
